import React from 'react';
import { FaChartLine, FaDownload, FaFilePdf, FaFileCsv } from 'react-icons/fa';
import WaveChart from '../../SuperAdmin/shared/WaveChart';
import './RecruiterReports.css';

const RecruiterReports = () => {
    const hiringData = [
        { name: 'Jan', count: 12 },
        { name: 'Feb', count: 18 },
        { name: 'Mar', count: 15 },
        { name: 'Apr', count: 25 },
        { name: 'May', count: 22 },
        { name: 'Jun', count: 30 },
    ];

    const conversionData = [
        { name: 'Applied', count: 400 },
        { name: 'Shortlisted', count: 120 },
        { name: 'Interviewed', count: 45 },
        { name: 'Offered', count: 12 },
    ];

    return (
        <div className="dashboard-overview fade-in">
            <div className="dashboard-header">
                <h1 className="page-title">Hiring Analytics</h1>
                <p className="page-subtitle">Track your recruitment performance and efficiency metrics.</p>
            </div>

            <div className="reports-grid">
                <div className="premium-card wide">
                    <div className="section-header">
                        <h3>Applicant growth trend</h3>
                        <FaChartLine />
                    </div>
                    <WaveChart data={hiringData} xKey="name" yKey="count" />
                </div>

                <div className="premium-card">
                    <div className="section-header">
                        <h3>Pipeline Efficiency</h3>
                    </div>
                    <div className="pipeline-viz">
                        {conversionData.map((item, i) => (
                            <div key={i} className="pipeline-step">
                                <div className="step-bar" style={{ width: `${(item.count / 400) * 100}%` }}>
                                    <span>{item.name}</span>
                                    <strong>{item.count}</strong>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="premium-card">
                    <div className="section-header">
                        <h3>Time to Hire (Avg)</h3>
                    </div>
                    <div className="stat-circle">
                        <svg viewBox="0 0 36 36" className="circular-chart">
                            <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                            <path className="circle" strokeDasharray="75, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                            <text x="18" y="20.35" className="percentage">14</text>
                            <text x="18" y="24" className="sublabel">Days</text>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecruiterReports;
